import React from 'react';
import MainContext from '../../contexts/MainContext';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration, getCurrencyValue } from '../../data/utils';
import { getLabel } from '../../InitData';

function FastbetToggle(props) {
    const betslipContext = React.useContext(BetslipContext);
    const mainContext = React.useContext(MainContext);

    const conf = getConfiguration();
    const amount = getCurrencyValue(betslipContext.addAndBetAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);

    function toggleFastbet() {
        if (betslipContext.isAddAndBetEnabled()) {
            betslipContext.disableAddAndBet();
        } else {
            mainContext.toggleFastbetPopup();
        }
    }

    function handleChangeAmount() {
        mainContext.toggleFastbetPopup();
    }

    const isEnabled = betslipContext.isAddAndBetEnabled();

    return (
        <div className="betslip-container-switch-fastbet">
            <label className="custom-switch-2">
                <input id="fastBetBtn" type="checkbox" onChange={toggleFastbet} checked={isEnabled}></input>
                <span className="custom-slider-2 round"></span>
            </label>
            <span className="ml-2">{getLabel('live.fastbet')}</span>
            {isEnabled &&
                <span className="bg-bianco ml-auto pointer" onClick={handleChangeAmount}>{amount}</span>
            }
        </div>
    );
}

export default FastbetToggle;